"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unwrapLink = void 0;
const slate_1 = require("slate");
exports.unwrapLink = (editor) => {
    slate_1.Editor.removeMark(editor, 'link');
};
//# sourceMappingURL=unwrap-link.js.map